import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

export default function Item({ place }) {
  if (!place) {
    return null;
  }

  return (
    <Link to={`/places/${place.id}`} className="img-card">
      <img src={place.logo} alt="" className="img-card-image" />
      <div className="img-card-info bl-center-x-pos">
        <div className="img-card-title">{place.name}</div>
        <div className="fw-600 fs-12">{place.address.full}</div>
      </div>
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Places/components/List/Item.js